export default __webpack_public_path__ + "static/media/placeholder2@2x.86847521.png";